// IMPORTANT: keep this as the FIRST import so the IST timezone override is
// installed before any other module reads or formats a Date.
import "@/lib/timezoneOverride";

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// v109 — Silence the harmless "ResizeObserver loop completed with undelivered
// notifications" warning. Triggered by shadcn Selects inside scrollable
// dialogs (Trainers → Raise Training Request → Report To). Filtering it out
// keeps the console clean without hiding real errors.
if (typeof window !== "undefined") {
  const RO_ERR_RE = /ResizeObserver loop (?:limit exceeded|completed with undelivered notifications)/;
  window.addEventListener("error", (e) => {
    if (e && e.message && RO_ERR_RE.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
  window.addEventListener("unhandledrejection", (e) => {
    const msg = (e && e.reason && (e.reason.message || String(e.reason))) || "";
    if (RO_ERR_RE.test(msg)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
